module.exports = __webpack_public_path__ + "img/es_Ecran 5.baeb06e8.png";